export const GRID_SEARCH_ALL_STATE_KEY = "gridSearchAll";

const readPendingGridSearch = (state: unknown): string | null => {
	if (!state || typeof state !== "object" || !(GRID_SEARCH_ALL_STATE_KEY in state)) {
		return null;
	}
	const value = (state as Record<string, unknown>)[GRID_SEARCH_ALL_STATE_KEY];
	return typeof value === "string" && value.trim() !== "" ? value : null;
};

export default readPendingGridSearch;
